export const createDictionary = (): any => Object.create(null);
